export const leftMenuFeatures = {
  "Novo!": "Novo!"
};



// WEBPACK FOOTER //
// ./src/resources/ptBR/leftMenuFeatures.js